import QueryTn from "./QueryTn";

export default QueryTn;
